import { Modal, ModalContent, Button, Image, Text, chakra, Box, } from "@chakra-ui/react";
import styled from "@emotion/styled";
import * as React from "react";
import { useEffect, useState } from "react";
import Web3Modal from "web3Modal";
import { WalletConnectProviderOptions } from "../constants/providerOptions";
var ConnectionModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, connectMetamask = _a.connectMetamask, connectWalletConnect = _a.connectWalletConnect, connectTorus = _a.connectTorus;
    var detect = require("detect-browser").detect;
    var browser = detect();
    // Check if user has MetaMask plugin in the browser
    var _b = useState(false), userHasMetaMask = _b[0], setUserHasMetaMask = _b[1];
    var _c = useState(null), web3Modal = _c[0], setWeb3Modal = _c[1];
    // Check if user had MetaMask extension
    useEffect(function () {
        if (window.ethereum && isOpen) {
            setUserHasMetaMask(true);
        }
    }, [isOpen]);
    // useEffect to initialise modal
    useEffect(function () {
        if (typeof window !== "undefined" && !web3Modal) {
            var modal = new Web3Modal({
                network: "mainnet",
                cacheProvider: false,
                providerOptions: WalletConnectProviderOptions, // required
            });
            setWeb3Modal(modal);
        }
    }, [web3Modal, setWeb3Modal]);
    var downloadMetamaskHandler = function () {
        window.open("https://metamask.io/download/", "_blank");
        onClose();
    };
    var DownloadMetamask = function () { return (React.createElement(React.Fragment, null,
        React.createElement(StyledBtn, { borderRadius: "0", onClick: downloadMetamaskHandler, borderBottom: "1px solid black" },
            React.createElement(Box, { pl: "60px" },
                React.createElement(StyledImage, { src: "https://cdn.shopify.com/s/files/1/0610/6831/2753/files/metamask.png?v=1663891617", alt: "MetaMask logo" })),
            React.createElement(Box, { margin: "auto", padding: "0px 25px 0px 25px" },
                React.createElement(ButtonText, null, "Download MetaMask"))))); };
    var ConnectWithSocials = function () { return (React.createElement(StyledBtn, { borderRadius: "50px 50px 0px 0px", borderBottom: "1px solid black", onClick: function () {
            connectTorus();
            onClose();
        } },
        React.createElement(Box, { pl: "60px" },
            React.createElement(StyledImage, { src: "https://cdn.shopify.com/s/files/1/0610/6831/2753/files/torus_wallet_logo.png?v=1663891617", alt: "Torus logo" })),
        React.createElement(Box, { margin: "auto", padding: "0px 25px 0px 25px" },
            React.createElement(ButtonText, null, "Connect with Socials")))); };
    var ConnectToMetamask = function () { return (React.createElement(React.Fragment, null,
        React.createElement(StyledBtn, { borderBottom: "1px solid black", onClick: function () {
                connectMetamask();
                onClose();
            } },
            React.createElement(Box, { pl: "60px" },
                React.createElement(StyledImage, { src: "https://cdn.shopify.com/s/files/1/0610/6831/2753/files/metamask.png?v=1663891617", alt: "MetaMask logo" })),
            React.createElement(Box, { margin: "auto", padding: "0px 45px 0px 25px" },
                React.createElement(ButtonText, null, "MetaMask"))))); };
    var ConnectToWalletConnect = function () { return (React.createElement(StyledBtn, { borderRadius: "0px 0px 50px 50px", onClick: function () {
            connectWalletConnect();
            onClose();
        } },
        React.createElement(Box, { pl: "60px" },
            React.createElement(StyledImage, { src: "https://cdn.shopify.com/s/files/1/0610/6831/2753/files/wallet-connect.svg?v=1663891617", alt: "WalletConnect logo" })),
        React.createElement(Box, { margin: "auto", padding: "0px 45px 0px 25px" },
            React.createElement(ButtonText, null, "WalletConnect")))); };
    return (React.createElement(Modal, { isOpen: isOpen, onClose: onClose, id: "connectionModal" },
        React.createElement(WalletModalContent, null,
            React.createElement(React.Fragment, null,
                React.createElement(ConnectWithSocials, null),
                !userHasMetaMask && React.createElement(DownloadMetamask, null),
                userHasMetaMask && React.createElement(ConnectToMetamask, null),
                React.createElement(ConnectToWalletConnect, null)))));
};
export default ConnectionModal;
var StyledBtn = chakra(Button, {
    baseStyle: {
        padding: "24px 25px",
        background: "white",
        height: "150px",
        width: "100%",
        display: "flex",
        flexDirection: "row",
        transition: "background 0.5s",
        _focus: {
            boxShadow: "none",
        },
        _hover: {
            background: "#9A9A9A",
        },
    },
});
var WalletModalContent = styled(ModalContent)({
    borderRadius: "50px",
    border: "1px solid black",
    width: "400px",
    opacity: 1,
    margin: "auto",
});
var StyledImage = styled(Image)({
    width: "80px",
    height: "80px",
    marigin: "auto",
});
var ButtonText = styled(Text)({
    color: "black",
    fontWeight: "800",
});
